export default function ThemeWrapper({ children }) {
    return (
        <div className="bg-gray-50 border-t-4 border-red-600 w-full max-w-full overflow-x-hidden">
            {children}
        </div>
    );
}